<template>
  <div class="wrapper">
    <div class="news_box">
      <scroll
        class="wrapper"
        :data="dataList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="dataList.length"
      >
        <section class="top_btn">
        <p class="statusBtn" @click="btnClick">全部已读</p>
        </section>
        <div
          class="list_item"
          v-for="(item,index) in dataList"
          :key="index"
          @click="toDetail(item)"
        >
          <i class="tips" v-if="item.isRead != 1"></i>
          <img :src="item.h5Type | typeImg" alt>
          <div class="item_center">
            <div class="item_center_title">
              <h3>
                {{item.title}}
              </h3>
              <span>{{item.createTime | showtimeStr}}</span>
            </div>
            <p>{{item.message}}</p>
          </div>
        </div>
      </scroll>
      <no-message v-if="dataList.length == 0 && loaded"></no-message>
    </div>
  </div>
</template>

<script>
import Scroll from '../../components/scroll';
import NoMessage from '../../components/nomessage';
import util from '../../utils/util';
import {
  getMsgByUserId,
  getMsgDetailById,
  batchReadMsg
} from '../../utils/api';
import { mapState } from 'vuex';

export default {
  name: 'news',
  components: {
    Scroll,
    NoMessage
  },
  data () {
    return {
      pageNo: 1,
      type: 0,
      allLoaded: false,
      loaded: false,
      dataList: []
    };
  },
  filters: {
    newsType (val) {
      return val === 2 ? '积分变动' : '优惠活动';
    },
    typeImg (val) {
      if (val === 2) {
        return require('../../assets/images/active.png');
      } else {
        return require(`../../assets/images/points_0.png`);
      }
    },
    showtimeStr (dataStr) {
      // let curDate = new Date().valueOf();
      // 当天凌晨时间戳
      let curD_min = new Date(new Date().setHours(0, 0, 0, 0)).valueOf();
      let curD_max = new Date(new Date().setHours(23, 59, 59, 59)).valueOf();
      if(dataStr > curD_min){
        return util.formatTime(new Date(dataStr), 22)
      }else if(dataStr > curD_min+86400000 && dataStr < curD_max+86400000){
        return '昨天' + util.formatTime(new Date(dataStr), 22)
      }else if(dataStr > curD_min+86400000*2 && dataStr < curD_max+86400000*2){
        return '前天' + util.formatTime(new Date(dataStr), 22)
      }else{
        return util.formatTime(new Date(dataStr), 11)
      }
    }
  },
  computed: {
    ...mapState({
      common:state => state.common,
      openId: state => state.common.openId,
      userId: state => state.common.userId,
      marketInfo: state => state.common.marketInfo
    })
  },
  activated () {
    // h5Type 1 园区活动  2 积分变动 3 报名进度
    // this.getMsgByUserId();
    util.showLoading()
    this.getMsgByUserId();
  },
  methods: {
    loadData () {
      this.pageNo = 1;
      this.getMsgByUserId();
    },
    loadup () {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getMsgByUserId();
    },
    toDetail (item) {
      if (item.isRead === 0) {
        this.getMsgDetails(item);
      }
      if(item.msgType== 5){
        //企业认证
        if(item.appUrl.indexOf('approvalList') > -1){
          let id = JSON.parse(item.options).ibp_id;
          this.$router.push(`/approvalDetail?id=${id}`);
        }else{
          this.$router.push('/companyList');
        }
        // this.$router.push('/approvalList');
      }else if(item.msgType == 9){
        //活动详情
        let id = JSON.parse(item.options).ibp_id;
         var url = `/activityDetails/${id}`;
         if(this.common.marketInfo.id){
            url =url +"?marketId="+this.common.marketInfo.id
         if(this.common.cityId){
            url =url +"&cityId="+this.common.cityId
         }
        }
        this.$router.push(url);
      }else if(item.msgType == 7){
        //会议室订单
        let id = JSON.parse(item.options).ibp_id;
        this.$router.push(`/meetingOrder/?id=${id}`);
      }else if(item.msgType == 4){
        //活动订单详情
        let appUrl = item.appUrl;
        let id = appUrl.split("=")[1];
        this.$router.push(`/activityOrder/?id=${id}`);
      }else if(item.msgType == 11){
        //拜访详情
        let id = JSON.parse(item.options).ibp_id;
        this.$router.push(`/visitDetails/?id=${id}`);
      }else if(item.msgType == 12){
        //拜访详情
        let id = JSON.parse(item.options).ibp_id;
        this.$router.push(`/VisitorReservationDetail/${id}`);
      }else if(item.msgType == 1){
        // 租赁账单
        this.$router.push(`/bill`);
      }
      // if (item.h5Type === 2) {
      //   this.$router.push('/mall/mypoints');
      // } else {
      //   let appUrl = item.appUrl;
      //   let id = appUrl.split('actId=')[1];
      //   this.$router.push(`/activityDetails/${id}`);
      // }
    },
    // 获取列表数据
    getMsgByUserId () {
      this.allLoaded = false;
      let params = {
        userId: this.userId,
        type: this.type,
        pageNo: this.pageNo,
        pageSize: 10
      };
      getMsgByUserId(params, { openId: this.openId }).then(res => {
        util.hideLoading();
        console.log(res);
        if (res.res.code === 10000) {
          if (res.body.msgList.length !== 10) {
            this.allLoaded = true;
          }
          if (this.pageNo === 1) {
            this.dataList = res.body.msgList;
          } else {
            this.dataList = [...this.dataList, ...res.body.msgList];
          }
        } else {
          util.showToast(res.res.msg);
        }
        this.loaded = true;
      });
    },
    // 标记为已点
    getMsgDetails (item) {
      let params = {
        userId: this.userId,
        msgId: item.id
      };
      getMsgDetailById(params).then(res => {
        console.log(res);
        item.isRead = true;
      });
    },
    // 全部标记为已点
    btnClick () {
      util.showLoading('加载中...')
      batchReadMsg({ userId: this.userId }, { openId: this.openId }).then(
        res => {
          util.hideLoading()
          console.log(res);
          if (res.res.code === 10000) {
            util.showToast('操作成功');
            this.pageNo = 1;
            this.getMsgByUserId();
          }
        }
      );
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background: #eee;
}
.top_btn{
  padding-top:14px;
}
.statusBtn {
  width: 136px;
  height: 52px;
  background: #e4e4e4;
  border-radius: 28px;
  .border();
  text-align: center;
  line-height: 52px;
  margin:20px auto;
  .fontSize(14px);
  color: @color9;
}
.news_box {
  padding: 0 30px;
  height: 100vh;
  box-sizing:border-box;
  .list_item {
    .flex();
    justify-content: space-between;
    align-items: center;
    position: relative;
    background:#fff;
    // height:88px;
    border-radius:8px;
    margin-bottom:20px;
    padding:28px 20px;
    .tips{
      position:absolute;
      top:20px;left:20px;
      display:block;
      background: #fc3f56;
      border-radius: 100%;
      width: 12px;
      height: 12px;
      z-index:2;
    }
    > img {
      display: block;
      height: 44px;
      width: 44px;
      margin-right:28px;
    }
    .item_center {
      flex:1;
      .item_center_title {
        .flex();
        justify-content: space-between;
        h3 {
          height: 40px;
          .fontSize(14px);
          font-weight: bold;
          color: @color3;
          line-height: 40px;
          margin-bottom: 14px;
          .flex();
          align-items: center;
          i {
          }
        }
        > span {
          height: 40px;
          .fontSize(12px);
          color: @color9;
          line-height: 40px;
          display: block;
        }
      }
      p {
        .fontSize(12px);
        color: @color9;
        line-height: 34px;
        // max-height: 68px;
        overflow: hidden;
      }
    }
    .item_right {
      position: absolute;
      top: 50px;
      height: 76px;
      right: 0;
      text-align: right;
      span {
        height: 32px;
        .fontSize(12px);
        color: @color6;
        line-height: 32px;
        display: block;
        margin-bottom: 12px;
      }
      i {
        display: inline-block;
        padding: 0 8px;
        height: 32px;
        line-height: 32px;
        border-radius: 16px;
        background: @colorff;
        color: #fff;
        .fontSize(12px);
        background: @colorff;
      }
    }
  }
  .last {
    border: 0;
  }
}
</style>
